module.exports = __webpack_public_path__ + "static/media/image6.c04d3750.png";